import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import formSlice from "./formSlice";
import userSlice from "./userSlice";
import refereeSlice from "./refereeSlice";
import proposalSlice from "./proposalSlice";
import researchauthoritiesSlice from "./researchauthoritiesSlice";
import messagesSlice from "./messagesSlice";
import applicantsSlice from "./applicantsSlice";
import advisorSlice from "./advisorSlice";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import {
  FLUSH,
  PAUSE,
  REHYDRATE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist/es/constants";

const persistConfig = {
  key: "gif-portal",
  storage: storageSession,
  blacklist: ["applicants/as"],
};

const combinedReducer = combineReducers({
  currentForm: formSlice,
  user: userSlice,
  applicants: applicantsSlice,
  referee: refereeSlice,
  institution: researchauthoritiesSlice,
  advisor: advisorSlice,
  proposal: proposalSlice,
  messages: messagesSlice,
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGGED_OUT") {
    state = undefined;
  }
  return combinedReducer(state, action);
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

function storeBuilder() {
  const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  });
  const persistor = persistStore(store);
  return { store, persistor };
}
const presitentStore = storeBuilder();
export default presitentStore;
